import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

import { loadAdminPageRSC } from './server.functions.js';
import { getAdminHead, searchToRecord } from '~/lib/payload-admin-route';
import type { AdminRouteData } from '~/lib/payload-admin-route';

export const Route = createFileRoute('/_payload/admin/')({
  head: ({ loaderData }: { loaderData?: AdminRouteData }) => getAdminHead(loaderData?.metadata),
  loader: {
    handler: async ({ location }: { location: { searchStr: string } }) => {
      const data = (await loadAdminPageRSC({
        data: { _splat: '', search: searchToRecord(location.searchStr) },
      })) as AdminRouteData;
      if (data?._redirect) throw redirect({ to: data._redirect });
      if (data?._notFound) throw notFound();
      return data;
    },
    staleReloadMode: 'blocking',
  },
  loaderDeps: ({ search }: { search: unknown }) => ({ searchKey: JSON.stringify(search) }),
  validateSearch: (search: unknown) => search,
} as never);
